import { render, staticRenderFns } from "./ReturnItemBase.vue?vue&type=template&id=688b6e09&"
import script from "./ReturnItemBase.vue?vue&type=script&lang=js&"
export * from "./ReturnItemBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports